<template>
  <div class="home-camera">
    <div id="video-player"></div>

    <div class="home-camera-mask">
      <div
        class="home-camera-tip"
        v-for="(device, index) in devices"
        :key="index"
      >
        {{ device.name }}
      </div>
    </div>
  </div>
</template>

<script>
import EZUIKit from '@/assets/js/ezuikit'
import { getAddress } from '@/service/camera'
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      loading: false,
      address: [],
      token: '',
      decoder: null
    }
  },
  beforeDestroy() {
    if (this.decoder) {
      removeResizeListener(this.$el, this.resizeHandler)
      this.decoder.stop(0)
      this.decoder.destroy()
    }
  },
  mounted() {
    addResizeListener(this.$el, this.resizeHandler)
    this.getAddress()
  },
  computed: {
    split() {
      return Math.pow(Math.ceil(Math.sqrt(this.address.length)), 2)
    },
    urls() {
      return this.address.map(a => a.live).join(',')
    },
    devices() {
      return this.address.map(a => {
        const device = this.cameras.find(c => c.key === a.key)
        return device
      })
    }
  },
  methods: {
    async getAddress() {
      this.loading = true
      const { data } = await getAddress(this.companyId)
      let address = data.cameras.filter(c => c.status === 1)
      if (address.length > 4) {
        address = address.slice(0, 4)
      }
      this.address = address
      this.token = data.token
      this.loading = false
      this.initPlay()
    },
    initPlay() {
      this.loading = true
      const width = this.$el.offsetWidth - 80
      const height = this.$el.offsetHeight - 80

      this.decoder = new EZUIKit.EZUIPlayer({
        id: 'video-player',
        autoplay: true,
        url: this.urls,
        accessToken: this.token,
        decoderPath: process.env.NODE_ENV === 'production' ? '/v3' : '',
        width,
        height,
        splitBasis: this.split,
        onLoaded: () => {
          this.loading = false
        }
      })

      this.loading = false
    },
    resizeHandler() {
      const width = this.$el.offsetWidth - 80
      const height = this.$el.offsetHeight - 80
      this.decoder && this.decoder.reSize(width, height)
    }
  }
}
</script>

<style lang="scss">
.home-camera {
  background-image: url('~@/assets/images/map-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 40px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  #video-player {
    width: 100%;
    height: 100%;
    background-color: #000;
  }
  .device-map-wrap {
  }
  .home-camera-mask {
    position: absolute;
    top: 40px;
    left: 40px;
    color: #fff;
    width: calc(100% - 80px);
    height: calc(100% - 80px);
    user-select: none;
    pointer-events: none;
  }
  .home-camera-tip {
    display: inline-block;
    width: 48%;
    height: 50%;
    text-align: right;
    line-height: 2rem;
  }
}
</style>
